import { Navigate, useLocation } from 'react-router-dom';

import type { ReactNode } from 'react';

import { isAuthenticated } from '@/lib/auth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

export function PublicOnlyRoute({ children }: { children: ReactNode }) {
  if (isAuthenticated()) {
    return <Navigate to='/app' replace />;
  }
  return <>{children}</>;
}
